import axios from 'axios'

export default {
	_get (uri) {
		return axios.get('galerias/php/api/' + uri)
	},
	_post (uri, datos) {
		return axios.post('galerias/php/api/' + uri, datos)
	},
	setGaleria (datos) {
		const form = JSON.parse(JSON.stringify(datos))
		form.FechaGaleria = Math.floor(datos.FechaGaleria.getTime() / 1000)
		return this._post('set-galeria.php', form)
	},
	delGaleria (GaleriaID) {
		return this._post('del-galeria.php', {GaleriaID: GaleriaID})
	},
	getGaleria (idGaleria) {
		return this._post('get-galeria.php', {GaleriaID: idGaleria})
	},
	getItem (ItemID) {
		const form = {
			ItemID: ItemID
		}
		return this._post('get-item.php', form)
	},
	delItem (ItemID) {
		return this._post('del-item.php', {ItemID: ItemID})
	},
	getGalerias (idUltima) {
		return this._post('get-galerias.php', {idUltima: idUltima})
	},
	addItemTag (idItem, etiqueta) {
		const form = {
			ItemID: idItem,
			etiqueta: etiqueta
		}
		return this._post('set-etiqueta-item.php', form)
	},
	delItemTag (idItem, etiqueta) {
		const form = {
			ItemID: idItem,
			etiqueta: etiqueta
		}
		return this._post('del-etiqueta-item.php', form)
	},
	setPortada (GaleriaID, ItemID) {
		const form = {
			GaleriaID: GaleriaID,
			ItemID: ItemID
		}
		return this._post('set-portada.php', form)
	},
	setPersona (ItemID, PersonaID, Nombre) {
		const form = {
			ItemID: ItemID,
			PersonaID: PersonaID,
			Nombre: Nombre
		}
		return this._post('set-persona-item.php', form)
	},
	delPersona (ItemID, PersonaID) {
		const form = {
			ItemID: ItemID,
			PersonaID: PersonaID
		}
		return this._post('del-persona-item.php', form)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/galerias/vue/api.js